<template>
  <div class="box_about">
    <div class="banner">
      <!-- <img src="../assets/about.png" alt=""> -->
        <h1>关于我们</h1>
        <!-- <p>介绍</p> -->
        <div class="inner_btn">
            <button @click="goToContact(2)" class="inner-le">生态合作</button>
            <button @click="goToContact(3)" class="inner-ri">联系我们</button>
         </div>
    </div>
  </div>
  <div class="about-main">
    <el-tabs
    v-model="activeName"
    type="card"
    class="demo-tabs"
    @tab-click="handleClick"
  >
    <el-tab-pane label="公司简介" name="first">
      <AboutAccompany/>
    </el-tab-pane>
    <el-tab-pane label="荣誉与资格" name="second">
      <HonorBook/>
    </el-tab-pane>
    <el-tab-pane label="联系我们" name="third">
      <LinkAbout/>
    </el-tab-pane>
  </el-tabs>
  </div>
</template>

<script setup name="AboutUs">
import AboutAccompany from '@/components/AboutAccompany.vue';
import HonorBook from '@/components/HonorBook.vue';
import LinkAbout from '@/components/LinkAbout.vue';
import { ref } from 'vue';
import { onMounted } from 'vue';
const activeName = ref('first');
onMounted(() => {
  window.scrollTo(0, 0);
})
const emit = defineEmits(['scroll-to-contact'])
function goToContact(type) {
  emit('scroll-to-contact', type)
}
</script>

<style scoped>
.banner{
  overflow: hidden;
  width: 100%;
  height: 11em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color:white;
  background-color: #ddd;
  margin-bottom: 8em;
  background-image: url('https://official-web-static.womucloud.com/bigBanner/pc/about.jpg');
  background-size: cover;
  background-position: center;
  text-align: center;
  background-repeat: no-repeat;
}
.inner-le,.inner-ri{
  width: 10em;
  height: 3em;
  border-radius: 1.5em;
  font-size: 1em;
  border:transparent;
  cursor: pointer;
  margin: 0.5em auto;
}
.inner_btn{
  font-size: 1em;
}
.inner-le{
  background-color: orange;
  color: white;
  margin-right: 1em;
}
.inner-ri{
  background-color: skyblue;
  color: white;
}
.banner h1{
  width: 65%;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 auto;
  color: white;
}
.el-tabs{
  width: 80%;
  margin: 0 auto;
}
@media (max-width: 1024px)  {
  .banner{
    height: 11em;
    background-image: url('https://official-web-static.womucloud.com/bigBanner/m/about.jpg');
    margin-bottom: 1em;
    text-align: center;
    gap: 0.8em;
  }
  .banner h1{
    font-size: 1.2em;
  }
  .inner-le,.inner-ri{
    font-size: 0.8em;
    height: 2.5em;
  }
.el-tabs{
  width: 95%;
  margin: 0 auto;
}
}
</style>